import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingRerpotTypeFilter } from '../../model/billing/index';
import { ReportViewer } from '../../model/report-viewer';
import { DownloadLocalFileService } from '../download-local-file.service';

@Injectable({
  providedIn: 'root'
})
export class BillingReportService {

  constructor( private dataService: DataService, private downloadLocalFileService: DownloadLocalFileService ) { }

  private readonly getBillingReportTypeFiltersEndPoint: string =
    '/billingReport/getBillingReportTypeFilters/';

  private readonly getBillingReportEndPoint: string =
    '/billingReport/getBillingReport/';

      private readonly exportExcelBillingEndPoint: string =
    '/billingReport/exportExcelBilling/';

  async getBillingReport(billingReportTypeId: number,
    billingInvoiceId: number, centerId: number): Promise<ReportViewer> {

    const params = { billingReportTypeId, billingInvoiceId, centerId };
    return await this.dataService
                      .get<ReportViewer>
                          (this.getBillingReportEndPoint, params)
                      .toPromise();
  }

  async getBillingReportTypeFilters(): Promise<BillingRerpotTypeFilter[]> {
    return await this.dataService
                      .get<BillingRerpotTypeFilter[]>
                          (this.getBillingReportTypeFiltersEndPoint, {})
                      .toPromise();
  }


  async exportExcelBilling(id: number): Promise<any> {
    const file = await this.dataService
      .post<string>(`${this.exportExcelBillingEndPoint}`, {
        id
      })
      .toPromise();

     this.downloadLocalFileService.downLoadFile(file, 'Export', 'xlsx');
  }
}
